import React, { useEffect, useState } from "react";
import OrbButton from "../../../../shared/components/orb-button";
import SyInput from "../../../../shared/forms/sy-input-form";
import SyIcon from "../../../../shared/components/sy-icon";
import { donatePopup, inputProps } from "./add-donate-interface";
import styleSheet from "./style.module.scss";
import SyChips from "../../../../shared/components/sy-chip";
import { dropOption, healConfig } from "./config";
import SyDropdown from "../../../../shared/forms/sy-dropdown";
import { Controller, useForm } from "react-hook-form";

type FormValues = {
  eur: number;
  Vorname: string;
  Nachname: string;
  eMail: any;
  StraBe: string;
  Hausrunmmer: string;
  PLZ: string;
  Ort: string;
  Land: any;
  Offentlicher: string;
  Kommentar: string;
  kontoinhaber: string;
  IBAN: string;
};

const AddDonate = (props: donatePopup) => {
  const { close } = props;
  const [paymentSelect, setpaymentSelect] = useState("");
  const [periodSelect, setperiodSelect] = useState("");
  const [payCardSelect, setpayCardSelect] = useState("");

  const onPaymetClick = (data: any) => {
    setpaymentSelect(data.index);
  };

  const onPeriodClick = (index: any) => {
    setperiodSelect(index);
  };
  const onPayCardClick = (index: any) => {
    setpayCardSelect(index);
  };
  const handleDateFilter = () => void 0;
  const handleDateLabel = (data: any) => data?.name;

  const {
    handleSubmit,
    control,
    register,
    setValue,
    setFocus,
    formState: { isValid, errors },
  } = useForm<FormValues>({});

  useEffect(() => {
    if (paymentSelect == "3") {
      setFocus("eur");
    }
  }, [paymentSelect]);

  const InputField = (props: inputProps) => {
    const { name, type, placeholder, inputType, selected } = props;
    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <SyInput
              {...register(name)}
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              inputType={inputType}
              selected={selected}
            />
          );
        }}
      />
    );
  };

  const onSubmit = (Formvalue: any) => {
    close("save");
  };

  return (
    <div
      className={`${styleSheet.main} container sy-scroll-x sy-scroll-y mt-5 position-relative `}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className={`${styleSheet.header} z-3 d-flex position-sticky top-0 border-bottom py-2 mb-5  bg-white `}
        >
          <div className="w-100 d-flex justify-content-center  ">
            <h5 className="text-dark mb-0 pb-0 mohave-bold ">
              {healConfig.heading}
            </h5>
          </div>
          <div className=" position-absolute end-0 d-flex justify-content-end ">
            <SyIcon name={"close"} className={"pointer"} onClick={close} />
          </div>
        </div>
        <div className="">
          <div className="px-1 mb-5 ">
            <div className="d-flex">
              <div
                className={`${styleSheet.dot} rounded-circle d-flex justify-content-center align-items-center`}
              >
                {healConfig.type_1}
              </div>
              <h5 className="text-dark mb-0 pb-0 mohave-bold ms-2 mt-1">
                {healConfig.text_1}
              </h5>
            </div>
            <div className=" d-flex flex-wrap pt-3 ps-5">
              {healConfig.cashChip.map((data: any, index: any) => (
                <div key={index} className=" pe-2 pb-2 ">
                  <span
                    onClick={() => {
                      onPaymetClick({ index, data });
                    }}
                  >
                    <SyChips active={paymentSelect == index ? true : false}>
                      {data.textField ? (
                        <div className="justify-content-center pb-1 pt-2 px-4 pointer">
                          <h6 className=" mohave mb-2">{data.header}</h6>
                          <div className="d-flex justify-content-center ">
                            <InputField
                              name={"eur"}
                              type={"number"}
                              inputType={"hidden"}
                              selected={paymentSelect == index ? true : false}
                            />
                            <h6 className=" mohave mb-0 mt-1">{data.type}</h6>
                          </div>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center pt-2 pointer ">
                          <h1 className="bebas-neue ">{data.amount}</h1>
                          <h6 className="mt-3  ms-2 mohave">{data.type}</h6>
                        </div>
                      )}
                    </SyChips>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div>
          <div className="px-1 mb-5">
            <div className="d-flex">
              <div
                className={`${styleSheet.dot} rounded-circle d-flex justify-content-center align-items-center`}
              >
                {healConfig.type_2}
              </div>
              <h5 className="text-dark mb-0 pb-0 mohave-bold ms-2 mt-1">
                {healConfig.text_2}
              </h5>
            </div>
            <div className="d-flex flex-wrap pt-3 ps-5">
              {healConfig.lableChip.map((data: any, index: any) => (
                <div key={index} className="pe-2 pb-2 pointer">
                  <span
                    onClick={() => {
                      onPeriodClick(index);
                    }}
                  >
                    <SyChips
                      lable={data.name}
                      active={periodSelect == index ? true : false}
                    />
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div>
          <div
            className="px-1
        mb-5"
          >
            <div className="d-flex mb-3">
              <div
                className={`${styleSheet.dot} rounded-circle d-flex justify-content-center align-items-center`}
              >
                {healConfig.type_3}
              </div>
              <h5 className="text-dark mb-0 pb-0 mohave-bold ms-2 mt-1">
                {healConfig.text_3}
              </h5>
            </div>

            <div className="row mb-3 ps-5">
              <div className="py-2  col-md-3 col-sm-6 col-xm-12">
                <InputField
                  name={"Vorname"}
                  type={"text"}
                  placeholder="Vorname"
                  inputType={"light"}
                />
              </div>
              <div className="py-2 col-md-3 col-sm-6 col-xm-12 ">
                <InputField
                  name={"Nachname"}
                  type={"text"}
                  placeholder="Nachname"
                  inputType={"light"}
                />
              </div>
              <div className="py-2 col-md-6 col-sm-12">
                <InputField
                  name={"email"}
                  type={"email"}
                  placeholder="e-Mail"
                  inputType={"light"}
                />
              </div>

              <div className="py-2 col-sm-6 col-xm-12">
                <InputField
                  name={"StraBe"}
                  type={"text"}
                  placeholder="StraBe"
                  inputType={"light"}
                />
              </div>
              <div className="py-2 col-sm-6 col-xm-12">
                <InputField
                  name={"Hausrunmmer"}
                  type={"text"}
                  placeholder="Hausrunmmer"
                  inputType={"light"}
                />
              </div>

              <div className="py-2 col-md-3 col-sm-6 col-xm-12">
                <InputField
                  name={"PLZ"}
                  type={"text"}
                  placeholder="PLZ"
                  inputType={"light"}
                />
              </div>
              <div className="py-2 col-md-3 col-sm-6 col-xm-12">
                <InputField
                  name={"Ort"}
                  type={"text"}
                  placeholder="Ort"
                  inputType={"light"}
                />
              </div>
              <div className="py-2 col-md-6 col-sm-12">
                <Controller
                  name="Land"
                  control={control}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <SyDropdown
                        options={dropOption}
                        placeholder={"Land"}
                        handleFilter={handleDateFilter}
                        handleChange={onChange}
                        getoptlabel={handleDateLabel}
                        value={value}
                        clearIcon={true}
                        type={"light"}
                      />
                    );
                  }}
                />
              </div>
            </div>
          </div>

          <div
            className="px-1
        mb-5"
          >
            <div className="d-flex mb-3">
              <div
                className={`${styleSheet.dot} rounded-circle d-flex justify-content-center align-items-center`}
              >
                {healConfig.type_4}
              </div>
              <h5 className="text-dark mb-0 pb-0 mohave-bold ms-2 mt-1">
                {healConfig.text_4}
              </h5>
            </div>

            <div className="row mb-3 ps-5">
              <div className="col-sm-6 col-xm-12 py-2">
                <InputField
                  name={"Offentlicher"}
                  type={"text"}
                  placeholder="Offentlicher"
                  inputType={"light"}
                />
              </div>
              <div className="col-sm-6 col-xm-12 py-2">
                <InputField
                  name={"Kommentar"}
                  type={"text"}
                  placeholder="Kommentar"
                  inputType={"light"}
                />
              </div>
            </div>
          </div>
          <div className="px-1 mb-5">
            <div className="d-flex">
              <div
                className={`${styleSheet.dot} rounded-circle d-flex justify-content-center align-items-center`}
              >
                {healConfig.type_5}
              </div>
              <h5 className="text-dark mb-0 pb-0 mohave-bold ms-2 mt-1">
                {healConfig.text_5}
              </h5>
            </div>
            <div className="d-flex flex-wrap pt-3 ps-5 pb-5">
              {healConfig.paymentChip.map((data: any, index: any) => (
                <div key={index} className="pe-2 pb-2 pointer">
                  <span
                    onClick={() => {
                      onPayCardClick(index);
                    }}
                  >
                    <SyChips active={payCardSelect == index ? true : false}>
                      <img src={data.img} className={`${styleSheet.image} `} />
                    </SyChips>
                  </span>
                </div>
              ))}
            </div>
            <div className="ps-5">
              <h6 className="text-dark mb-0 pb-0 mohave-bold ms-2 mt-1 ">
                {healConfig.contact_heading}
              </h6>
            </div>

            <div className="row  pt-3 ps-5">
              <div className="col-sm-6 col-xm-12 py-2">
                <InputField
                  name={"kontoinhaber"}
                  type={"text"}
                  placeholder="kontoinhaber"
                  inputType={"light"}
                />
              </div>
              <div className="col-sm-6 col-xm-12 py-2">
                <InputField
                  name={"IBAN"}
                  type={"text"}
                  placeholder="IBAN"
                  inputType={"light"}
                />
              </div>
            </div>
            <div className="d-flex pt-4 ps-5">
              <div className="">
                <SyIcon name={"lock"} iconColor="green" />
              </div>
              <div className="p-0 m-0">
                <p className={`${styleSheet.note_size} m-0 bebas-neue `}>
                  {healConfig.lock_heading}
                </p>
                <p className={`${styleSheet.note_size} m-0 mohave `}>
                  {healConfig.lock_paragraph}
                </p>
              </div>
            </div>
            <div className="mt-4 ms-5 mb-5">
              <OrbButton
                iconName={"universal_currency_alt"}
                iconType="symbols"
                label={"jetzt senden"}
                iconColor="white"
                className={`${styleSheet.button}`}
                type="submit"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddDonate;
